module.exports = __webpack_public_path__ + "img/find-a-matching-driver-for-your-led-module.3bd53e0e.png";